<div class="timeout-error-message">
    <h3>{{errorText}}</h3>
</div>